$(document).on('turbo:load', () => {
  $('#credit-card-number-field').on('keyup', (event) => {
    var value = $(event.target).val();
    var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || '';
    var parts = [];

    for (i=0, len=match.length; i<len; i+=4) {
        parts.push(match.substring(i, i+4));
    }

    var newValue;
    if (parts.length) {
        newValue = parts.join(' ');
    } else {
        newValue = value;
    }

    $(event.target).val(newValue);

  });
});